// extracted by mini-css-extract-plugin
export var printerCard = "_ab-1";
export var printerCardConfigured = "_ab-2";
export var printerCardError = "_ab-3";
export var printerCardsContainer = "_ab-0";
export var printerIcon = "_ab-8";
export var printerIconConfigured = "_ab-5";
export var printerIconContainer = "_ab-4";
export var printerIconError = "_ab-6";
export var printerIconUnconfigured = "_ab-7";